export default __webpack_public_path__ + "static/media/kalahastiTemple2.8023211e.png";